import { isUploadedFile } from "./isUploadedFile.mjs";
import { isObject } from "./isObject.mjs";

function isNonEmptyString(value) {
  return typeof value === 'string' && value.length > 0;
}

export function isUploadedImage(file) {
  return isObject(file) && isUploadedFile(file) && typeof file.original_height === 'number' && typeof file.original_width === 'number' && file.original_height > 0 && file.original_width > 0 && Array.isArray(file.effects) && file.effects.every(isNonEmptyString);
}